import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { HttpHeader } from '../core/httpheader';
import { jobapplication, EmpInfo, cspformsmodel } from './index.model';
import { API_URL, API_JobApplication, API_HouseCheck, API_PDFService } from '../core/apiconfig';
import { OTPModel } from './otp.model';
import { SessionStorageService } from '../core/index.service';
import { CitizenInfoBase } from '../citizen/index.model';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class jobAppilcationService {
    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http, private session: SessionStorageService) {
        this.apiUrl = API_URL + API_JobApplication;
    }

    getjobApplicationInfo(jurisID: number): Promise<jobapplication[]> {
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http
            .get(this.apiUrl + "/GetActiveJobs/" + jurisID, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {

                return response.json() as jobapplication[];
            })
            .catch(this.handleError);
    } 

    // Handle Error

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }

    //Send OTP 8562201384
    SentOTP(mobileNo: String, jurisID: number): Promise<OTPModel> {
        return this._http
            .get(API_URL + API_JobApplication + '/SentOTP/' + mobileNo + '/' + jurisID)
            .toPromise()

            .catch(this.handleError);
    }

    PdfSentOTP(mobileNo: String, jurisID: number){
        return this._http
            .get(API_URL + API_JobApplication + '/SentOTP/' + mobileNo + '/' + jurisID)
            .map((res: Response) => res).pipe(
                retry(2),
                catchError(this.handleError))
    };

    PdfSentOTPtoEmail(Email: String, jurisID: number, FormType: string) {
        return this._http
            .get(API_URL + API_JobApplication + '/EmailOTPSent/' + Email + '/' + jurisID + '/' + FormType)
            .map((res: Response) => res).pipe(
                retry(2),
                catchError(this.handleError))
    };

    //validateOTP(userID: string, OTPNumber: number): Promise<OTPModel> {
    //    return this._http
    //        .get(API_URL + API_JobApplication + '/validateOTP/' + '1EA35EDD-1A4E-4D74-B6B5-E69A48F07B6A' + '/' + 52430)
    //        .toPromise()

    //        .catch(this.handleError);
    //}

    validateOTP(userID: string, OTPNumber: number): Promise<OTPModel> {
        return this._http
            .get(API_URL + API_JobApplication + '/validateOTP/' + userID + '/' + OTPNumber)
            .toPromise()

            .catch(this.handleError);
    }

    IsVerfiedOTP(userID: string, OTPNumber: number): Promise<OTPModel> {
        return this._http
            .get(API_URL + API_PDFService + '/IsVerfiedOTP/' + userID + '/' + OTPNumber)
            .toPromise()
            .catch(this.handleError);
    }

    //updateCsform
    //UpdateCSForm(empinfo: cspformsmodel): Promise<any> {
    //    let body = empinfo;
    //    return this._http
    //        .post(API_URL + API_HouseCheck + '/CSPFormsUpdate', body)
    //        .toPromise()

    //        .catch(this.handleError);
    //}


    UpdateCSForm(empinfo: cspformsmodel) {
        let body = empinfo;


        return this._http.post(API_URL + API_HouseCheck + '/CSPFormsUpdate', body)
            .map((res: Response) => res);
    }

    GeneratePDF(pdfdata: cspformsmodel): Promise<cspformsmodel> {
        let objectData = pdfdata;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.post(API_URL + "/" + API_PDFService + '/GenPDFTemplate', objectData, this.Http_Header_Request_Options)
            .toPromise()
            .catch(this.handleError);
    }

    //GeneratePDF(pdfdata: cspformsmodel) {
    //    let objectData = pdfdata;
    //    this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
    //    return this._http.post(API_URL + "/" + API_PDFService + '/GenPDFTemplate', objectData, this.Http_Header_Request_Options)
    //        .map((res: Response) => res);
    //}

}



// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/services/jobapplication.service.ts